import axios from "axios";
import Link from "next/link";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BreadcrumbComponent from "../../components/Common/BreadcrumbComponent";
import ExtraPageFooter from "../../components/Common/ExtraPageFooter";
import PageHeadingComponent from "../../components/Common/PageHeadingComponent";
import Footer from "../../components/_App/Footer";
import Header from "../../components/_App/Header";
import apiClient from "../../data/apiClient";
import { FOOTER_QUERY } from "../../data/pageQuery";

const MySwal = withReactContent(Swal);

const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
  });
};

const Downloads = ({ footer, menu }) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const filter = isAU ? "data/isAU/iv eq true" : "data/isNZ/iv eq true";
  const headingData = { heading: "Download Guides" };
  const breadcrumb = {
    breadcrumbs: [{ title: "Downloads" }],
  };
  const [isSearched, setIsSearched] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleClick = async (e) => {
    e.preventDefault();
    if (!searchTerm) {
      showAlert("Please enter a search term");
      return;
    }
    const search = searchTerm.toString();
    try {
      setIsLoading(true);
      const resp = await axios.post("/api/downloads", {
        search: `\"${search}\"`,
      });
      setIsLoading(false);
      setIsSearched(true);
      if (resp.data) {
        if (resp.data?.data) {
          setSearchResults(resp.data?.data);
        } else {
          setSearchResults([]);
        }
      } else {
        showAlert("Unexpected Error, please try again.");
        return;
      }
    } catch (error) {
      setIsLoading(false);
      //console.log(error);
      showAlert("Unexpected Error, please try again.");
      return;
    }
  };

  return (
    <>
      <Header {...menu} />
      <BreadcrumbComponent {...breadcrumb} />
      <PageHeadingComponent {...headingData} />
      <div className='container my-3'>
        <div className='row'>
          <div className='offset-md-3 col-md-6 col-xs-12'>
            <div>
              <form className='d-flex'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search by part number or term'
                  onChange={handleSearchTermChange}
                />
                <button
                  type='submit'
                  className='btn btn-primary'
                  onClick={handleClick}
                >
                  {isLoading && (
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  )}
                  {!isLoading && "Search"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='col'>{isSearched && <h2>Search Results</h2>}</div>
        </div>
        <div className='row'>
          <div className='offset-md-2 col-md-8'>
            {isSearched && searchResults.length == 0 && (
              <span>no matching data found</span>
            )}
            {searchResults.length > 0 && (
              <div>
                <table className='table table-responsive table-striped'>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Ryco Part No</th>
                      <th style={{ textAlign: "center" }}>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchResults.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          {item.flatData.stockCode} -{" "}
                          <span style={{ color: "gray" }}>
                            {item.flatData.typeName}
                          </span>
                        </td>
                        <td>
                          <table>
                            <tbody>
                              {item.flatData.fitmentGuides &&
                                item.flatData.fitmentGuides.map((ft, idx1) => (
                                  <tr key={idx1}>
                                    <td>
                                      <Link href={ft.url} legacyBehavior>
                                        <a target='_blank'>{ft.title}</a>
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                              {item.flatData.extraInfo?.downloads &&
                                item.flatData.extraInfo.downloads.map(
                                  (ft, idx1) => (
                                    <tr key={idx1}>
                                      <td>
                                        <Link
                                          href={ft.file[0].url}
                                          legacyBehavior
                                        >
                                          <a target='_blank'>{ft.title}</a>
                                        </Link>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2}>
                        {searchResults.length >= 250 && (
                          <span style={{ color: "gray" }}>
                            Only top 500 results shown
                          </span>
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
      <ExtraPageFooter />
      <Footer {...footer}></Footer>
    </>
  );
};

export async function getStaticProps() {
  const { data } = await(await apiClient()).query({
    query: FOOTER_QUERY,
    fetchPolicy: "cache",
  });

  const {
    queryFooterContents: footerContents,
    queryMenuContents: menuContents,
  } = data;

  const footerContent =
    footerContents[0] != null ? footerContents[0].flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  return {
    props: {
      footer: footerContent,
      menu: menuContent,
      seo: {
        title:
          "Downloads | Ryco Filters | Air Filters, Oil Filters and Fuel Filters | Automotive Filters",
        metadata: "Download the latest fitment guides - Ryco Filters",
        keywords: "Ryco Filters Downloads, Fitment Guide Downloads",
        socialTitle: `Ryco Filters Downloads`,
        isNzOnly: false,
        url: "/-/downloads",
      },
    },
    revalidate: 60 * 1, // in seconds
  };
}

export default Downloads;
